import { motion } from "framer-motion";
import { ExitButton } from "../elements/Button";

interface INotificationProps {
    show: boolean;
    title: string;
    text: string;
    onClose: () => void;
}

export function Notification({ show, title, text, onClose }: INotificationProps) {
    if (!show) {
        return null;
    }

    return (
        <motion.div
            initial={{
                top: '7vh',
                opacity: 0,
                right: '-15vw'
            }}
            animate={{
                position: 'fixed',
                opacity: 1,
                right: 0,
                top: '7vh',
            }}
            transition={{ duration: 0.75, ease: "easeInOut" }}
            style={{
                zIndex: 999,
            }}
            className="general-notification-container"
        >
            <div className="general-notification">
                <div className="header">
                    <h3>{title}</h3>
                    <ExitButton handleCallback={onClose} />
                </div>
                <div className="text">
                    <p>{text}</p>
                </div>
            </div>
        </motion.div>
    );
}
